import React from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import { ContainerWrapper, SectionHeader, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import Banner from "../Certificates/Components/Banner";

import BannerBig from "../../Images/min-sky.jpg";
import BannerSmall from "../../Images/max-sky.jpg";


class NoMatch extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "Page Not Found";
    return (
      <div className="App">
        <HelmetTitle title="Page not found" />
        <Layout
          head={<Navbar />}
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
              <Body 
                name={name} 
                logos={
                  <ContainerWrapper textAlign="justify">
                    <SectionHeader 
                      size="small" 
                      mt="2rem"
                      mb="2rem">We couldn't find what you requested.
                    </SectionHeader>
                    <p></p>
                    <p>Were you directed here from a different source? please ask for an updated link.</p>
                  </ContainerWrapper>
                } />
            </React.Fragment>
          }
         />
      </div>
    );
  }
}

export default withRouter(NoMatch)



// WEBPACK FOOTER //
// ./src/Pages/Misc/NoMatch.js